import { Fault } from "../flatbuffers/generated/fault/fault";
import { FaultContent } from "../flatbuffers/generated/fault/fault-content";

/**
 * The generated enum name for a fault code, chosen by device family.
 *
 * Elevators and escalators number their faults independently, so the same code
 * means different things depending on `faultContent`.
 */
export function getFaultEnumName(faultContent: FaultContent, code: Fault | Fault): string {
  if (faultContent === FaultContent.ElevatorFaultMessage) {
    return Fault[code] ?? `Unknown_${code}`;
  }
  if (faultContent === FaultContent.EscalatorFaultMessage) {
    return Fault[code] ?? `Unknown_${code}`;
  }
  return `Unknown_${code}`;
}

/**
 * The human-readable fault name shown in reports and on the monitoring grid.
 */
export default function getFaultDisplayName(
  faultContent: FaultContent,
  code: Fault | Fault,
): string {
  const enumName = getFaultEnumName(faultContent, code);
  if (enumName.startsWith("Unknown")) return enumName;
  return enumName.replace(/([A-Z])/g, " $1").trim();
}
